// extracted by mini-css-extract-plugin
export default {"tittle":"CustomSelectorSearch_tittle__Ze33Y"};